import RequireAuth from "../../components/RequireAuth";
import {PermissionLevel} from "../../app/api/model/user";
import {Route, Routes} from "react-router-dom";
import AssetsList from "./AssetsList";

export default function Assets() {
    return (
        <RequireAuth permissionLevel={PermissionLevel.VIEW_ONLY}>
            <Routes>
                <Route index element={<AssetsList />} />
            </Routes>
        </RequireAuth>
    );
}
